var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-avatar',{class:_vm.classObj,attrs:{"size":12}},[_c('v-icon')],1),(_vm.label)?_c('span',{staticStyle:{"margin-left":"0.5rem"}},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }